export default class Locale_CustomContractPropertiesDialog {
    SuccessUpdate: string = 'Updated custom properties for ';
    FailedUpdate: string = 'Failed to save custom properties for ';
    RevertButtonText: string = 'Revert';
    LoadingProperties: string = 'Loading properties...';
    UpdatingProperties: string = 'Updating properties...';
}
